// extracted by mini-css-extract-plugin
export var brand = "_2v-9";
export var button = "_2v-0";
export var chevron = "_2v-v";
export var chevronButton = "_2v-w";
export var content = "_2v-n";
export var danger = "_2v-g";
export var dangerOutlined = "_2v-h";
export var dark = "_2v-l";
export var darkTheme = "_2v-c";
export var extraSmall = "_2v-4";
export var fullWidth = "_2v-8";
export var ghost = "_2v-d";
export var gray = "_2v-t";
export var icon = "_2v-p";
export var iconButton = "_2v-s";
export var iconButtonBorder = "_2v-x";
export var iconButtonBorderDark = "_2v-y";
export var iconButtonBorderLight = "_2v-z";
export var iconLeft = "_2v-q";
export var iconRight = "_2v-r";
export var large = "_2v-1";
export var light = "_2v-m";
export var medium = "_2v-2";
export var micro = "_2v-5";
export var nano = "_2v-7";
export var outlined = "_2v-k";
export var pending = "_2v-a";
export var primary = "_2v-i";
export var shadow = "_2v-o";
export var small = "_2v-3";
export var solidLight = "_2v-e";
export var solidLightBrand = "_2v-f";
export var spinner = "_2v-u";
export var transparent = "_2v-j";
export var warning = "_2v-b";
export var wideNano = "_2v-6";